var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('question-renderer',{attrs:{"question":_vm.src,"indicator":_vm.indicator}})}
var staticRenderFns = []

export { render, staticRenderFns }